import { useState, useEffect } from 'react'

export const useExtraIncomeType = (goToNextScreen, incomeStatementPath, setDataModal) => {
  const [value, setValue] = useState()
  const [isButtonDisabled, setIsButtonDisabled] = useState(true)
  const [options, setOptions] = useState([])

  useEffect(() => {
    setDataModal(null)
  }, [setDataModal])

  useEffect(() => {
    if (
      incomeStatementPath &&
      incomeStatementPath.readExtraIncomeType &&
      incomeStatementPath.readExtraIncomeType.options &&
      incomeStatementPath.readExtraIncomeType.options.length > 0 &&
      incomeStatementPath.readExtraIncomeType.options
    ) {
      const newArray = incomeStatementPath.readExtraIncomeType.options.map(item => {
        incomeStatementPath.readExtraIncomeType.choosed.map(choosedId => {
          if (choosedId.answer) {
            onValueChange(false, choosedId.answer)
          }
          if (item.id === choosedId.id) {
            item.active = true
            setIsButtonDisabled(false)
          }
        })
        return item
      })
      setOptions(newArray)
    }
  }, [incomeStatementPath])

  useEffect(() => {
    const isActive = options.filter(item => item.active).length > 0
    setIsButtonDisabled(!isActive)
  }, [options])

  const onSelectOption = item => {
    const arrayNew = options.map(option => {
      if (item.active) {
        if (item.id === option.id) {
          item.active = false
          return option
        } else {
          return option
        }
      } else {
        if (item.id === option.id) {
          item.active = true
          return option
        } else {
          return option
        }
      }
    })

    setOptions(arrayNew)
    setValue('')
  }

  const onSubmit = e => {
    e.preventDefault()
    const body = []
    options.forEach(item => {
      if (item.active && item.requiresExplanation) {
        body.push({ id: item.id, answer: value })
        return false
      }
      if (item.active) {
        body.push({ id: item.id })
      }
    })

    goToNextScreen(body)
  }

  const handlerSelectOption = item => {
    onSelectOption(item)
    return false
  }

  const onValueChange = (which, valueData) => {
    let text
    if (valueData) {
      text = value
    } else {
      text = which.target.value
    }

    setValue(text)
  }
  return { handlerSelectOption, onSubmit, onValueChange, value, isButtonDisabled, options }
}
